import { BuildingAddress } from 'src/configs/APISchemas/Application.schema';
import { BillingAddress } from 'src/pages/payment-msi/PaymentMsiV2/types/billing-address.type';

const fallbackValue = '';

interface MapBuildingAddressToBillingAddressArgs {
  buildingAddress: BuildingAddress['value'];
  isCompany: boolean;
  buildingUnit?: string;
}

export const mapBuildingAddressToBillingAddress = ({
  buildingAddress,
  isCompany,
  buildingUnit,
}: MapBuildingAddressToBillingAddressArgs): BillingAddress => {
  const addressLine1 = getAddressLine1FromBuildingAddress(
    buildingAddress,
    isCompany,
  );

  return {
    state: buildingAddress.state ?? fallbackValue,
    city: buildingAddress.municipality,
    zipCode: buildingAddress.postalCode,
    addressLine1: addressLine1,
    addressLine2: buildingUnit ?? fallbackValue,
  };
};

const getAddressLine1FromBuildingAddress = (
  buildingAddress: BuildingAddress['value'],
  isCompany: boolean,
): string => {
  if (isCompany) {
    return buildingAddress.street ?? fallbackValue;
  }

  const addressNumber = buildingAddress.addressNumber ?? fallbackValue;
  const addressStreet = buildingAddress.street ?? fallbackValue;

  return `${addressNumber} ${addressStreet}`.trim();
};
